import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { PermissionsComponent } from '@nu-art/permissions-frontend';
import { ModuleFE_MouseInteractivity, mouseInteractivity_PopUp } from '@nu-art/thunderstorm-frontend/index';
export const ActionsMenu_BaseManagerUI = (props) => {
    return _jsx(_Fragment, { children: props.actions.map((action, index) => {
            if (!action.permissionKey)
                return _jsx("div", { className: 'popup-action', onClick: () => {
                        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                        action.action();
                    }, children: action.label }, index);
            return _jsx(PermissionsComponent, { permissionKey: action.permissionKey, children: _jsx("div", { className: 'popup-action', onClick: () => {
                        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                        action.action();
                    }, children: action.label }) }, index);
        }) });
};
//# sourceMappingURL=ActionsMenu_BaseManagerUI.js.map